<template>
  <div>
    <b-row>
      <b-col>
        <vs-card>
          <b-form-input v-model="orderNumber" @keyup.enter="filterOrderList()" id="smallInput"
            placeholder="Sipariş Numarasını Giriniz" />
        </vs-card>
      </b-col>
    </b-row>
    <b-row v-if="iadeler.length > 0">
      <b-col>
        <vs-card v-if="statusFlag">
          <h6 style="margin: 0px" class="text-danger">DİKKAT! Bu sipariş numarası daha önce işleme alınmış</h6>
        </vs-card>
        <vs-card>
          <h1>{{ iadeler[0].program }}</h1>
          <b-row align-v="center" style="margin-top:8px">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'Ad Soyad:'" label-for="h-first-name" style="font-weight: bold;font-size: larger;">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <h6 style="margin: 0px">{{ iadeler[0].shipFirstName }} {{ iadeler[0].shipLastName }}</h6>
            </b-col>
          </b-row>
          <b-row align-v="center" style="margin-top:8px">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'Sipariş Tarihi:'" label-for="h-first-name"
                style="font-weight: bold;font-size: larger;">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <h6 style="margin: 0px">{{ iadeler[0].siparisTarihi }} </h6>
            </b-col>
          </b-row>
          <b-row align-v="center" style="margin-top:8px">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'Sipariş Numarası:'" label-for="h-first-name"
                style="font-weight: bold;font-size: larger;">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <h6 style="margin: 0px">{{ iadeler[0].orderNumber }} </h6>
            </b-col>
          </b-row>
          <b-row align-v="center" style="margin-top:8px">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'Toplam Tutar:'" label-for="h-first-name"
                style="font-weight: bold;font-size: larger;">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <h6 style="margin: 0px">{{ iadeler[0].totalPrice.toFixed(2) }} </h6>
            </b-col>
          </b-row>

        </vs-card>
      </b-col>
      <b-col cols="7">
        <vs-card>
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="12">
                  <span>İade Tutarı </span>
                </b-col>
                <b-col>
                  <b-form-input label="Tutar" v-model="totalReturnPrice" id="smallInput" />
                </b-col>
              </b-row>

            </b-col>

          </b-row>
          <b-row style="margin-top:15px">
            <b-col>
              <vs-textarea label="Nedeni" v-model="iadeNedeni"></vs-textarea>
            </b-col>
            <b-col>
              <vs-textarea label="Açıklaması" v-model="iadeAciklamasi"></vs-textarea>
            </b-col>
          </b-row>
          <b-row style="margin-top:15px">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'Kargo Numarası:'" label-for="h-first-name"
                style="font-weight: bold;font-size: larger; ">
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <vs-input size="small" v-model="cargoNo" type="text" name="invoiceAddress" class="w-full" />
            </b-col>
          </b-row>
          <b-row style="margin-top:15px">
            <b-col cols="6">
              <b-button style="  border-color:white !important;" v-on:click="activePromptStockReturn = true"
                id="loading-stockList2" class="bg-primary-gradient vs-con-loading__container">
                <Icon icon="f7:return" width="20" height="20" v-b-tooltip.hover.bottom="'İade et'" /> İade et
              </b-button>
            </b-col>

            <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
              :suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="columnDefs"
              :rowData="iadeler" :localeText="localeText" @selection-changed="onSelectionChanged"
              @grid-ready="onGridReady" @cell-value-changed="onCellValueChanged" :isRowSelectable="isRowSelectable"
              @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection">
            </ag-grid-vue>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <vs-prompt color="warning" title="UYARI" acceptText="İade et" cancelText="Vazgeç" @accept="saveIade()"
      :active.sync="activePromptStockReturn"> İade işlemini onaylıyor musunuz ?
    </vs-prompt>
  </div>
</template>
<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
export default {
  data() {
    return {
      totalReturnPrice: 0.0,
      statusFlag: false,
      activePromptStockReturn: false,
      isRowSelectable: null,
      getSelectedJson: "",
      cargoNo: "",
      localeText: null,
      rowSelection: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      iadeler: [],
      orderNumber: "",
      totalPrice: "",
      selectedIslem: "",
      iadeNedeni: "",
      iadeAciklamasi: "",
      optionsFaturaDurumu: ["Var", "Yok"],
      optionsIslem: ["İade", "İptal"],
      optionsQuality: ["Sağlam", "Hasarlı"],
      selectedFaturaDurumu: ""
    }
  },
  methods: {
    onCellValueChanged(params) {
      var vs = this.$vs;
      console.log(params.data.quality)
      if (params.data.qty > 0 && params.data.qty <= params.data.quantity) {
        if (params.data.quality != "" && typeof params.data.quality != "undefined") {
          params.node.setSelected(true);
        }
        else {
          vs.notify({
            text: "Durum değeri seçilmelidir",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      }
      else {

        vs.notify({
          text: "Adet değeri sıfırdan büyük olmalı ve sipariş adet miktarını geçmemeli",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    onSelectionChanged() {
      const selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows)
      this.totalReturnPrice = 0.0;
      selectedRows.forEach((val, index) => {
        this.totalReturnPrice += val.price * val.quantity
      });
    },
    saveIade() {
      const selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows)
      let stockStr = "";
      selectedRows.forEach((val, index) => {
        stockStr += val.sku + "Æ" + val.qty + "_" + val.quality
        if (index != selectedRows.length - 1) stockStr += ","
      });
      var vm = this;

      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: vm.iadeler[0].program,
        orderNumber: vm.iadeler[0].orderNumber,
        stokkodlari: stockStr,
        iadeNedeni: vm.iadeNedeni,
        iadeAciklama: vm.iadeAciklamasi,
        gonderiKargoNo: vm.cargoNo,
        totalPrice: vm.totalReturnPrice

      };
      console.log(args)

      soap.createClient(url, function (err, client) {
        client.MauelIadeSiparisEkle(args, function (err, result) {
          if (result.MauelIadeSiparisEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let veriler = JSON.parse(result.MauelIadeSiparisEkleResult);
            console.log(veriler)
            if (veriler.error == "Yes") {
              vs.notify({
                text: "Başarısız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            } else {
              vm.filterOrderList();
              vs.notify({
                text: "Başarılı. İade kaydı yapıldı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }

          } catch (error) {
            console.log(error)
            vs.notify({
              text: "Başarısız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();

    },
    filterOrderList() {
      var vm = this;
      vm.statusFlag = false
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        orderNumber: vm.orderNumber
      };
      console.log(args)
      soap.createClient(url, function (err, client) {
        client.pazaryeriTamamlananSiparisCekManuel(args, function (err, result) {
          if (result.pazaryeriTamamlananSiparisCekManuelResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let veriler = JSON.parse(result.pazaryeriTamamlananSiparisCekManuelResult);
            console.log(veriler)
            vm.iadeler = veriler
            vm.totalPrice = vm.iadeler[0].totalPrice
            vm.iadeler.forEach((value, index) => {
              if (parseInt(value.durum) == 1) vm.statusFlag = true
            });
          } catch (error) {
            console.log(error)
            vs.notify({
              text: "Başarısız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },

  },
  components: {
    TextGorunumCellRenderer,
    Icon,
    "v-select": vSelect,
    AgGridVue,
  },
  created() {
    this.rowSelection = 'multiple';
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;

  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        checkboxSelection: (params) => {
          return false;
        },
        showDisabledCheckboxes: true,
        width: 25
      },
      {
        headerName: "Adet",
        field: "quantity",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        width: 75
      },
      {
        headerName: "Fiyat",
        field: "price",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        width: 100,
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: "Ürün adı",
        field: "productName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: 'İade Adedi',
        field: 'qty',
        editable: true,
        width: 75

      },
      {
        headerName: 'İade Durumu',
        field: 'quality',
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: { values: this.optionsQuality },
        editable: true,
      },
      {
        headerName: 'Durum',
        field: 'durum',
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: { values: this.optionsQuality },
        editable: true,
        width: 50
      },
    ];
  },
}
</script>